import React, { createContext, useContext, useMemo, useState } from "react";

const AppLanguageContext = createContext({
  language: "en",
  setLanguage: () => {},
  toggleLanguage: () => {},
});

export const AppLanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");

  const value = useMemo(() => ({
    language,
    setLanguage,
    toggleLanguage: () => setLanguage((current) => (current === "en" ? "vi" : "en")),
  }), [language]);

  return (
    <AppLanguageContext.Provider value={value}>
      {children}
    </AppLanguageContext.Provider>
  );
};

export const useAppLanguage = () => useContext(AppLanguageContext);
